import { message } from 'antd';
import { formatoMonedaGenerico } from '../utils/converters';

// eslint-disable-next-line import/prefer-default-export
export const controlMinMax = (plan, montomm, i, moneda) => {
  let max;
  let min;
  const newPlan = plan;
  newPlan.planSubcobertura[i].monto = Number(montomm);
  max = newPlan.planSubcobertura[i].monto_max;
  min = newPlan.planSubcobertura[i].monto_min;
  if (!(max > 0 && min > 0)) {
    if (!max > 0) {
      max = newPlan.planSubcobertura[i].subcobertura.monto_max;
    }
    if (!min >= 1) {
      min = newPlan.planSubcobertura[i].subcobertura.monto_min;
    }
  }
  const item = newPlan.planSubcobertura[i];
  if (
    (item.subcobertura.opcion === 'valor_capital' &&
      plan.monto_total &&
      `${item.monto}` !== '-1' &&
      Number(montomm) !== 0) ||
    (item.subcobertura.opcion === 'valor_capital' && Number(montomm) >= 1)
  ) {
    if (montomm < min && min) {
      message.info({
        content: `El valor mínimo permitido es de ${formatoMonedaGenerico(
          moneda,
          min
        )}`,
        duration: 10
      });
      newPlan.planSubcobertura[i].monto = Number(min);
      newPlan.planSubcobertura[i].changed = true;
    }
    if (montomm > max && max) {
      message.info({
        content: `El valor máximo permitido es de ${formatoMonedaGenerico(
          moneda,
          max
        )}`,
        duration: 10
      });
      newPlan.planSubcobertura[i].monto = Number(max);
      newPlan.planSubcobertura[i].changed = true;
    }
  }
  return newPlan;
};
